import React from 'react'
import {Navbar} from 'react-bootstrap';

function TopComp() {
    
    return (
      <div>
{/*
<div class="row pirmasblokas1 justify-content-end"  >
<Navbar  className=" navbar-dark"  >
<Nav className="mr-auto " >
<Nav.Item  className="px-3" style={{ fontWeight: 600 }}>
    <Nav.Link href="#" target="_blank">TINKLAPIAI</Nav.Link>
</Nav.Item>
<Nav.Item className="px-3" style={{ fontWeight: 600 }}>
    <Nav.Link href="#" target="_blank">MAKETAVIMAS</Nav.Link>
</Nav.Item>
<Nav.Item className="px-3" style={{ fontWeight: 600 }}>
    <Nav.Link href="#" target="_blank">SUSIPAŽINKIM</Nav.Link>
</Nav.Item>
</Nav>
</Navbar>
</div> 
*/}
        <div class="row pirmasblokas sonai ">
            <Navbar bg="none" variant="dark">
            <Navbar.Brand href="/"  className="first text-wrap">
            DONATAS MISIUNAS
            </Navbar.Brand>
            </Navbar>
        </div>
    </div>
    )
}

export default TopComp